import { formatPagination } from '~/services/formatters'
import { toCamelCase } from '~/utils/object'

export function formatClassifiedReportResult(r: any) {
  return {
    reports: (r.rows || []).map(formatClassifiedReport),
    pagination: formatPagination(r.pagination)
  }
}

export function formatClassifiedReport(classifiedReport: any) {
  return toCamelCase(classifiedReport)
}
